/**
 * Represents a feedback item.
 * @typedef {Object} FeedbackItem
 * @property {string} username - The username of the person submitting the feedback.
 * @property {string} date - The date the feedback was submitted.
 * @property {string} text - InnerHTML feedback text.
 * @property {string} generalFeedback Count of general feedback.
 * @property {Array} ratingStars - Array of rating items.
 * @property {Array} tags - Array of rating items.
 */


import SportRouteStar from "./SportRouteStar";
import SportRouteRatingTags from "./SportRouteRatingTags";
import React from "react";
import SportRouteRatingStars from "./SportRouteRatingStars";

/**
 * @param {{comments: FeedbackItem[]}} props
 */
export default function (props) {
    return (
        <>
            <h6 className={"c-sportroute__comments__title"}>Reacties ({props.comments.length})</h6>
            <div className="c-sportroute__comments">
                {props.comments.map((comment, index) => (
                    <div key={index} className="c-sportroute__comment">
                        <div
                            className={`c-sportroute__comment__header ${comment.generalFeedback ? '' : 'c-sportroute__comment__header__single-child'}`}>
                            {comment.generalFeedback &&
                                <div className="c-sportroute__comment__header__rating">
                                    <SportRouteStar filled={true}></SportRouteStar>
                                    <div>{comment.generalFeedback}</div>
                                </div>
                            }

                            <div className="c-sportroute__comment__header__info">
                                <span>Sport Vlaanderen gebruiker</span>
                                <span>||</span>
                                <span>{comment.username}</span>
                                <span>||</span>
                                <span>{comment.date}</span>
                            </div>
                        </div>

                        {((comment.ratingStars && comment.ratingStars.length > 0) || (comment.tags && comment.tags.length > 0)) &&
                            <div className="c-sportroute__comment__feedback">
                                {comment.ratingStars && comment.ratingStars.length > 0 &&
                                    <SportRouteRatingStars items={comment.ratingStars}/>}
                                {comment.tags && comment.tags.length > 0 &&
                                    <SportRouteRatingTags items={comment.tags}/>}
                            </div>}
                        <div className="c-sportroute__comment__content"
                             dangerouslySetInnerHTML={{__html: comment.text}}/>
                    </div>))}
            </div>
        </>)

}